var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUser = function SvgIcnUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentcolor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0221 20.6959C9.11046 20.36 7.16 19.7804 7.16 19.7804C7.16 19.7804 8.81731 14.3051 8.81731 11.0479V9.21017C8.81731 5.78695 11.5216 3 14.8577 3H17.1423C20.4807 3 23.1827 5.77984 23.1827 9.21017V11.0479C23.1827 14.3051 24.84 19.7804 24.84 19.7804C24.84 19.7804 22.8895 20.36 19.9779 20.6959L20.3503 22.9989L25.0462 24.0389C27.3943 25.0085 29 26.0432 29 26.842V29.0068H16.52V29H15.48V29.0068H3V26.842C3 26.0432 4.6057 25.0085 6.95382 24.0389L11.6497 22.9989L12.0221 20.6959Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_user.de159508.svg";
export { ForwardRef as ReactComponent };